
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "customer-portal-app",
  currentProjectVersion: "static-1.3448",
  depVersions: {
  "customer-portal-app": "static-1.3448",
  "apollo-dlb": "static-3.98",
  "avatar-components": "static-1.2973",
  "client-types": "static-1.511",
  "data-fetching-client": "static-1.10125",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26525",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6078",
  "hs-test-utils": "static-1.8525",
  "hub-http": "static-1.6692",
  "hub-http-shared-msw-handlers": "static-1.10923",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19304",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11973",
  "I18n": "static-7.1709",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6939",
  "payment-link-components": "static-1.24480",
  "portals-platform-bend-plugin": "static-1.27",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7682",
  "quartz-core": "static-1.6901",
  "quartz-i18n": "static-1.1357",
  "react": "static-7.203",
  "react-colorpicker": "static-2.10696",
  "react-dlb": "static-1.94",
  "react-utils": "static-2.5665",
  "reselect": "static-3.16",
  "rich-text-lib": "static-1.20573",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18554",
  "ui-components-test-utils": "static-1.6110",
  "UIComponents": "static-3.8919",
  "video-player-core": "static-1.21",
  "foundations-assets": "static-1.5374",
  "foundations-components": "static-1.8768",
  "foundations-theming": "static-1.4976",
  "foundations-theming-specialty": "static-1.2692",
  "framer-motion": "static-1.84",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1711",
  "quartz-config": "static-1.1460",
  "quartz-routing": "static-1.1112",
  "quick-fetch": "static-1.4238",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fkhalid-vitals-reporter-delete-lcp.3",
  "rpc-client-utils": "static-1.5155",
  "sanitize-text": "static-1.8644",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.66",
  "ui-addon-draggable": "static-3.5235",
  "ui-addon-react-router-dom": "static-1.10011",
  "usage-tracker": "static-1.7809",
  "usage-tracker-anonymous": "static-1.6226",
  "usage-tracker-core": "static-1.7659",
  "video-components-external": "static-1.12464",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3959",
  "quartz-webpack": "static-1.3906",
  "bend-plugin-quartz-routing": "static-1.760",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4982",
  "icons": "static-2.704",
  "StyleGuideUI": "static-3.518",
  "trellis-components": "static-1.3135",
  "trellis-migration-context": "static-1.67",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.93",
  "customer-data-objects": "static-1.8193",
  "frontend-preferences-client": "static-1.8408",
  "laboratory-lib": "static-3.7633",
  "onboarding-scopes": "static-1.6940",
  "seat-types-lib": "static-1.1070",
  "ui-addon-opt": "static-4.8900",
  "HeadJS": "static-2.824",
  "hs-test-utils-bend-plugin": "static-1.3636",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.165",
  "hs-locale-management": "static-1.409",
  "ts-schema": "static-1.4402",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8440",
  "content-media-capture": "static-1.5817",
  "cssUtils": "static-1.1109",
  "customer-data-ui-utilities": "static-1.10318",
  "file-manager-components": "static-1.24861",
  "HubStyle": "static-2.12280",
  "knowledge-content-types": "static-1.8766",
  "PatternValidationJS": "static-1.3370",
  "react-input-autosize": "static-2.17",
  "ui-addon-emoji-picker": "static-1.10349",
  "ui-addon-i18n": "static-1.11631",
  "ui-business-units-lib": "static-1.9583",
  "ui-shepherd-react": "static-3.10766",
  "video-data-lib": "static-1.36122",
  "i18n-data": "static-1.235",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4792",
  "commerce-tours-lib": "static-1.6879",
  "customer-data-properties": "static-1.53087",
  "getting-started-shared-tasks": "static-1.19587",
  "growth-onboarding-reliability": "static-1.5570",
  "onboarding-tours": "static-1.17411",
  "reference-resolvers-lite": "static-1.8599",
  "sales-checkout-service-client": "static-1.4007",
  "ui-addon-iframeable": "static-1.9564",
  "user-context": "static-1.5540",
  "bender-build-tools": "static-1.3600",
  "dispatcher": "static-1.148",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.39",
  "opentelemetry-fe": "static-1.652",
  "quartz-auth": "static-1.1357",
  "quartz-head": "static-1.1347",
  "quartz-test": "static-1.1357",
  "quartz-tracking": "static-1.1061",
  "ui-fonts": "static-1.1235",
  "usage-tracker-container": "static-1.7799",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9915",
  "data-token-picker": "static-1.17154",
  "FileManagerLib": "static-1.40501",
  "property-translator": "static-1.5866",
  "merchandise-lib": "static-1.286",
  "purchase-motions-components": "static-1.6647",
  "SharedI18nStrings": "static-1.188",
  "foundations-components-test-utils": "static-1.6251",
  "react-create-root-preference": "static-1.105",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "ui-images": "static-2.1278",
  "bend-plugin-foundations-components": "static-1.5037",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "trellis-assets": "static-1.3116",
  "bend-plugin-foundations-theming": "static-1.3459",
  "foundations-theming-base": "static-1.3961",
  "stylex": "static-1.46",
  "interframe": "static-3.5228",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6223",
  "opentelemetry-fe-types": "static-1.277",
  "beacon-keepalive-queue": "static-1.186",
  "web-vitals": "static-1.19",
  "bend-plugin-chirp-manifest": "static-1.565",
  "chirp-fetch": "static-1.2391",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4961",
  "react-flip-move": "static-1.83",
  "apollo-link-hub-http": "static-2.5075",
  "content-media-composition-data-lib": "static-1.13621",
  "content-media-compositions": "static-2.17628",
  "idb-keyval": "static-1.55",
  "immer": "static-1.105",
  "immerable": "static-1.4628",
  "magpie-lib": "static-1.5916",
  "magpie-types": "static-1.5376",
  "media-bridge-lib": "static-1.19659",
  "sassPrefix": "static-1.374",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "trellis-theming": "static-1.1500",
  "tanstack-virtual": "static-1.43",
  "inbound-db-properties-service-client": "static-1.4158",
  "superstore": "static-1.5245",
  "feedback-loader": "static-1.30078",
  "ai-components-ui-library": "static-1.10044",
  "ui-addon-video-player": "static-1.9109",
  "ui-coaching-tips": "static-1.29595",
  "ContentUtils": "static-1.69502",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4915",
  "react-dnd-compat": "static-1.5096",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2229",
  "copilot-toolkit": "static-1.12175",
  "poll-commands": "static-1.3964",
  "atom": "static-1.5558",
  "navigation-messaging": "static-1.8522",
  "redux-thunk": "static-2.84",
  "reference-resolvers": "static-1.8670",
  "commerce-products-lib": "static-1.10940",
  "crm-message-bus": "static-1.44135",
  "growth-data-modal": "static-1.6153",
  "hubspot-apollo-client": "static-1.5369",
  "onboarding-tours-client": "static-1.5626",
  "batch-promise": "static-1.2035",
  "calling-global-api": "static-1.66227",
  "calling-internal-common": "static-1.31811",
  "calling-lifecycle-internal": "static-1.67609",
  "calling-lifecycle-messages": "static-1.59901",
  "conditional-properties-service-client": "static-1.4120",
  "crm-index-visualization-core": "static-1.4774",
  "crm-links": "static-1.6799",
  "crm-pipelines-api-client-types": "static-1.4451",
  "customer-data-objects-ui-components": "static-1.13522",
  "customer-data-properties-shared-msw-handlers": "static-1.10250",
  "customer-data-property-utils": "static-1.8538",
  "data-agent-utils": "static-1.952",
  "external-options-client-types": "static-1.4446",
  "formula-editor": "static-1.15026",
  "google-libphonenumber": "static-1.50",
  "hs-resources": "static-1.671",
  "inbound-db-meta-service-client": "static-1.3782",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1118",
  "multi-currency-client-types": "static-1.4015",
  "object-builder-ui-client": "static-1.50076",
  "pipeline-validation-client-types": "static-1.4290",
  "property-value-citations": "static-1.3701",
  "pulse": "static-1.1134",
  "smart-data-capture-core": "static-1.507",
  "smart-property-lib": "static-1.8683",
  "tiered-pricing": "static-1.2302",
  "topics-actions-lib": "static-1.670",
  "trellis-ext-i18n": "static-1.1405",
  "trial-components-library": "static-1.14401",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "growth-onboarding-confetti": "static-1.3544",
  "growth-onboarding-next-action-utils": "static-1.3008",
  "navigation-components": "static-1.19195",
  "nest": "static-1.722",
  "onboarding-tours-utils": "static-1.1478",
  "ui-shepherd-tracker": "static-1.8147",
  "ui-universal-auth": "static-1.9766",
  "getting-started-shared-tasks-store": "static-1.18705",
  "opentelemetry-web": "static-1.23",
  "hubspotter-http-shared-msw-handlers": "static-1.10921",
  "usage-tracker-session-replay": "static-1.5495",
  "audio-components": "static-1.6590",
  "FileManagerCore": "static-1.40360",
  "FileManagerImages": "static-1.38012",
  "video-components": "static-1.14466",
  "foundations-components-legacy": "static-1.1793",
  "purchase-motions-api": "static-1.6650",
  "signup-constants": "static-1.19966",
  "signup-ui-url-generator": "static-2.8524",
  "stylex-utils": "static-1.176",
  "usage-tracker-public": "static-1.7620",
  "reactive-lib": "static-1.1207",
  "simple-logging-lib": "static-1.3537",
  "nudge-client-utils": "static-1.3442",
  "chatspot-core": "static-1.23952",
  "growth-onboarding-feedback-components": "static-1.7067",
  "cms-field-types": "static-1.5296",
  "content-icons-ui": "static-1.2468",
  "integrations-lib": "static-1.17457",
  "underscore": "static-1.8",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1207",
  "breeze-engine-core": "static-1.1507",
  "highlight.js": "static-1.90",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30832",
  "commerce-permissions": "static-1.1272",
  "customer-data-tracking": "static-1.7358",
  "products-iframe-lib": "static-1.8938",
  "products-ui-components-shared-msw-handlers": "static-1.11305",
  "restore-request-side-panel-lib": "static-1.2049",
  "onboarding-data-sync-lib": "static-1.2857",
  "hubspot-apollo-cache": "static-1.828",
  "calling-error-reporting": "static-1.31818",
  "shared-worker-versioning": "static-1.11530",
  "calling-usage-tracker": "static-1.7027",
  "conversations-skeleton-state": "static-1.7609",
  "voice-sms-access-library": "static-1.2488",
  "crm-index-associations-lib": "static-1.6934",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11006",
  "redux-toolkit": "static-1.82",
  "sales-views-client-types": "static-1.4745",
  "framework-data-schema-resolvers": "static-1.7379",
  "location-customization-utils-lib": "static-1.10444",
  "data-agent-kit": "static-1.939",
  "enrichment-settings-lib": "static-1.256",
  "fsm": "static-1.4244",
  "policy-lib": "static-1.7290",
  "bark-lib": "static-1.17020",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6383",
  "react-codemirror": "static-1.11128",
  "event-emitter": "static-1.1448",
  "fdsr-migration-layer": "static-1.498",
  "framework-builder-read-service-client": "static-1.4342",
  "bend-plugin-pulse": "static-1.637",
  "fast-json-patch": "static-1.74",
  "data-agent-test-utils": "static-1.483",
  "react-tinymce": "static-1.56289",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11069",
  "tinymce-config": "static-2.55415",
  "tinymce-plugins": "static-1.58529",
  "embedded-academy-lib": "static-1.16041",
  "hubs-service-types": "static-1.1754",
  "salesImages": "static-1.744",
  "growth-onboarding-next-action-components": "static-1.3036",
  "user-context-client": "static-1.4996",
  "custom-vendor-connection-lib": "static-1.330",
  "unified-auth-core-lib": "static-1.1562",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.1018",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.5000",
  "video-embed": "static-1.36956",
  "social-insights-client-types": "static-1.22952",
  "nudge-custom-function-registry": "static-1.3199",
  "nudge-renderer-utils": "static-1.3518",
  "whisper-core-api": "static-1.7661",
  "flux-actions": "static-1.381",
  "integrations-error-boundary-lib": "static-1.14872",
  "integrations-tracking-lib": "static-1.6109",
  "native-integrations-shared-strings": "static-1.8249",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10856",
  "rxjs": "static-5.10",
  "InboxConnectUtils": "static-4.15864",
  "meetings-connect-utils-lib": "static-1.8106",
  "calling-orchestration-schema": "static-1.37265",
  "framework-data-schema-quick-fetch": "static-1.7284",
  "persist-promise": "static-1.4192",
  "crm-record-cards-service-types": "static-1.3871",
  "highcharts": "static-8.115",
  "trellis-story-utils": "static-1.4984",
  "storybook-react": "static-1.44",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16689",
  "browser-eslint": "static-2.57",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57385",
  "hub-http-contrib": "static-1.3519",
  "tinymce-data": "static-1.41500",
  "ui-addon-sales-email": "static-1.5688",
  "layout-dnd-components": "static-1.13245",
  "layout-dnd-utils": "static-1.12220",
  "ui-brand-identity-lib": "static-1.16980",
  "academy-common-lib": "static-1.15502",
  "outpost": "static-1.4615",
  "universal-page-editor-lib": "static-1.3499",
  "NamespacedHubStyle": "static-2.9375",
  "ContentData": "static-1.69577",
  "layout-data-lib": "static-1.10545",
  "academy-service-client": "static-1.4178",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4883",
  "trellis-ecosystem": "static-1.7869",
  "wootric-nps": "static-1.7305",
  "crm-record-cards-client": "static-1.83",
  "advanced-menus-core": "static-1.15835",
  "advanced-menus-lib": "static-1.12582",
  "ExportDialog": "static-6.10859",
  "ui-memberships-settings-lib": "static-1.35225",
  "marketplace-ui-apps-core": "static-1.19582",
  "marketplace-ui-common": "static-1.21050",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15834",
  "simple-menus-lib": "static-1.17351",
  "settings-ui-lib": "static-1.13014",
  "developer-experience-shared-components": "static-1.11027",
  "immutable-less": "static-1.5138",
  "marketplace-ui-client-types": "static-1.18457",
  "ui-addon-integrations-directory-panel": "static-2.8440",
  "ui-extensibility-client-types": "static-1.4401",
  "ai-settings-ui-library": "static-1.8613",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1611",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4623",
  "simple-data-table": "static-1.3845"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3448",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "avatar-components": "/avatar-components/static-1.2973",
  "client-types": "/client-types/static-1.511",
  "data-fetching-client": "/data-fetching-client/static-1.10125",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26525",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6078",
  "hs-test-utils": "/hs-test-utils/static-1.8525",
  "hub-http": "/hub-http/static-1.6692",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10923",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19304",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11973",
  "I18n": "/I18n/static-7.1709",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6939",
  "payment-link-components": "/payment-link-components/static-1.24480",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.27",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7682",
  "quartz-core": "/quartz-core/static-1.6901",
  "quartz-i18n": "/quartz-i18n/static-1.1357",
  "react": "/react/static-7.203",
  "react-colorpicker": "/react-colorpicker/static-2.10696",
  "react-dlb": "/react-dlb/static-1.94",
  "react-utils": "/react-utils/static-2.5665",
  "reselect": "/reselect/static-3.16",
  "rich-text-lib": "/rich-text-lib/static-1.20573",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18554",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6110",
  "UIComponents": "/UIComponents/static-3.8919",
  "video-player-core": "/video-player-core/static-1.21",
  "foundations-assets": "/foundations-assets/static-1.5374",
  "foundations-components": "/foundations-components/static-1.8768",
  "foundations-theming": "/foundations-theming/static-1.4976",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2692",
  "framer-motion": "/framer-motion/static-1.84",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1711",
  "quartz-config": "/quartz-config/static-1.1460",
  "quartz-routing": "/quartz-routing/static-1.1112",
  "quick-fetch": "/quick-fetch/static-1.4238",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-vitals-reporter-delete-lcp.3",
  "rpc-client-utils": "/rpc-client-utils/static-1.5155",
  "sanitize-text": "/sanitize-text/static-1.8644",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.66",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5235",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10011",
  "usage-tracker": "/usage-tracker/static-1.7809",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6226",
  "usage-tracker-core": "/usage-tracker-core/static-1.7659",
  "video-components-external": "/video-components-external/static-1.12464",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3959",
  "quartz-webpack": "/quartz-webpack/static-1.3906",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.760",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4982",
  "icons": "/icons/static-2.704",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "trellis-components": "/trellis-components/static-1.3135",
  "trellis-migration-context": "/trellis-migration-context/static-1.67",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.93",
  "customer-data-objects": "/customer-data-objects/static-1.8193",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8408",
  "laboratory-lib": "/laboratory-lib/static-3.7633",
  "onboarding-scopes": "/onboarding-scopes/static-1.6940",
  "seat-types-lib": "/seat-types-lib/static-1.1070",
  "ui-addon-opt": "/ui-addon-opt/static-4.8900",
  "HeadJS": "/HeadJS/static-2.824",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3636",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.165",
  "hs-locale-management": "/hs-locale-management/static-1.409",
  "ts-schema": "/ts-schema/static-1.4402",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8440",
  "content-media-capture": "/content-media-capture/static-1.5817",
  "cssUtils": "/cssUtils/static-1.1109",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10318",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "HubStyle": "/HubStyle/static-2.12280",
  "knowledge-content-types": "/knowledge-content-types/static-1.8766",
  "PatternValidationJS": "/PatternValidationJS/static-1.3370",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10349",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11631",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9583",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10766",
  "video-data-lib": "/video-data-lib/static-1.36122",
  "i18n-data": "/i18n-data/static-1.235",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4792",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6879",
  "customer-data-properties": "/customer-data-properties/static-1.53087",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19587",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5570",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8599",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4007",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9564",
  "user-context": "/user-context/static-1.5540",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "dispatcher": "/dispatcher/static-1.148",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.39",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.652",
  "quartz-auth": "/quartz-auth/static-1.1357",
  "quartz-head": "/quartz-head/static-1.1347",
  "quartz-test": "/quartz-test/static-1.1357",
  "quartz-tracking": "/quartz-tracking/static-1.1061",
  "ui-fonts": "/ui-fonts/static-1.1235",
  "usage-tracker-container": "/usage-tracker-container/static-1.7799",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9915",
  "data-token-picker": "/data-token-picker/static-1.17154",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "property-translator": "/property-translator/static-1.5866",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "purchase-motions-components": "/purchase-motions-components/static-1.6647",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6251",
  "react-create-root-preference": "/react-create-root-preference/static-1.105",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "ui-images": "/ui-images/static-2.1278",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5037",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "trellis-assets": "/trellis-assets/static-1.3116",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3459",
  "foundations-theming-base": "/foundations-theming-base/static-1.3961",
  "stylex": "/stylex/static-1.46",
  "interframe": "/interframe/static-3.5228",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6223",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.277",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.186",
  "web-vitals": "/web-vitals/static-1.19",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.565",
  "chirp-fetch": "/chirp-fetch/static-1.2391",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4961",
  "react-flip-move": "/react-flip-move/static-1.83",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5075",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "idb-keyval": "/idb-keyval/static-1.55",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4628",
  "magpie-lib": "/magpie-lib/static-1.5916",
  "magpie-types": "/magpie-types/static-1.5376",
  "media-bridge-lib": "/media-bridge-lib/static-1.19659",
  "sassPrefix": "/sassPrefix/static-1.374",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "trellis-theming": "/trellis-theming/static-1.1500",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4158",
  "superstore": "/superstore/static-1.5245",
  "feedback-loader": "/feedback-loader/static-1.30078",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10044",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9109",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29595",
  "ContentUtils": "/ContentUtils/static-1.69502",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4915",
  "react-dnd-compat": "/react-dnd-compat/static-1.5096",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2229",
  "copilot-toolkit": "/copilot-toolkit/static-1.12175",
  "poll-commands": "/poll-commands/static-1.3964",
  "atom": "/atom/static-1.5558",
  "navigation-messaging": "/navigation-messaging/static-1.8522",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reference-resolvers": "/reference-resolvers/static-1.8670",
  "commerce-products-lib": "/commerce-products-lib/static-1.10940",
  "crm-message-bus": "/crm-message-bus/static-1.44135",
  "growth-data-modal": "/growth-data-modal/static-1.6153",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5369",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "batch-promise": "/batch-promise/static-1.2035",
  "calling-global-api": "/calling-global-api/static-1.66227",
  "calling-internal-common": "/calling-internal-common/static-1.31811",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67609",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59901",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4120",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4774",
  "crm-links": "/crm-links/static-1.6799",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4451",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13522",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10250",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8538",
  "data-agent-utils": "/data-agent-utils/static-1.952",
  "external-options-client-types": "/external-options-client-types/static-1.4446",
  "formula-editor": "/formula-editor/static-1.15026",
  "google-libphonenumber": "/google-libphonenumber/static-1.50",
  "hs-resources": "/hs-resources/static-1.671",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3782",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1118",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4015",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50076",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4290",
  "property-value-citations": "/property-value-citations/static-1.3701",
  "pulse": "/pulse/static-1.1134",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.507",
  "smart-property-lib": "/smart-property-lib/static-1.8683",
  "tiered-pricing": "/tiered-pricing/static-1.2302",
  "topics-actions-lib": "/topics-actions-lib/static-1.670",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1405",
  "trial-components-library": "/trial-components-library/static-1.14401",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3544",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3008",
  "navigation-components": "/navigation-components/static-1.19195",
  "nest": "/nest/static-1.722",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8147",
  "ui-universal-auth": "/ui-universal-auth/static-1.9766",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18705",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10921",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5495",
  "audio-components": "/audio-components/static-1.6590",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "video-components": "/video-components/static-1.14466",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1793",
  "purchase-motions-api": "/purchase-motions-api/static-1.6650",
  "signup-constants": "/signup-constants/static-1.19966",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8524",
  "stylex-utils": "/stylex-utils/static-1.176",
  "usage-tracker-public": "/usage-tracker-public/static-1.7620",
  "reactive-lib": "/reactive-lib/static-1.1207",
  "simple-logging-lib": "/simple-logging-lib/static-1.3537",
  "nudge-client-utils": "/nudge-client-utils/static-1.3442",
  "chatspot-core": "/chatspot-core/static-1.23952",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7067",
  "cms-field-types": "/cms-field-types/static-1.5296",
  "content-icons-ui": "/content-icons-ui/static-1.2468",
  "integrations-lib": "/integrations-lib/static-1.17457",
  "underscore": "/underscore/static-1.8",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1207",
  "breeze-engine-core": "/breeze-engine-core/static-1.1507",
  "highlight.js": "/highlight.js/static-1.90",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30832",
  "commerce-permissions": "/commerce-permissions/static-1.1272",
  "customer-data-tracking": "/customer-data-tracking/static-1.7358",
  "products-iframe-lib": "/products-iframe-lib/static-1.8938",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11305",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2049",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2857",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.828",
  "calling-error-reporting": "/calling-error-reporting/static-1.31818",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11530",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7027",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7609",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2488",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6934",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11006",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "sales-views-client-types": "/sales-views-client-types/static-1.4745",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7379",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10444",
  "data-agent-kit": "/data-agent-kit/static-1.939",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.256",
  "fsm": "/fsm/static-1.4244",
  "policy-lib": "/policy-lib/static-1.7290",
  "bark-lib": "/bark-lib/static-1.17020",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6383",
  "react-codemirror": "/react-codemirror/static-1.11128",
  "event-emitter": "/event-emitter/static-1.1448",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.498",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4342",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.637",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.483",
  "react-tinymce": "/react-tinymce/static-1.56289",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11069",
  "tinymce-config": "/tinymce-config/static-2.55415",
  "tinymce-plugins": "/tinymce-plugins/static-1.58529",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16041",
  "hubs-service-types": "/hubs-service-types/static-1.1754",
  "salesImages": "/salesImages/static-1.744",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3036",
  "user-context-client": "/user-context-client/static-1.4996",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.330",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1562",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1018",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.5000",
  "video-embed": "/video-embed/static-1.36956",
  "social-insights-client-types": "/social-insights-client-types/static-1.22952",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3199",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3518",
  "whisper-core-api": "/whisper-core-api/static-1.7661",
  "flux-actions": "/flux-actions/static-1.381",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14872",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6109",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8249",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10856",
  "rxjs": "/rxjs/static-5.10",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15864",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8106",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37265",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7284",
  "persist-promise": "/persist-promise/static-1.4192",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "highcharts": "/highcharts/static-8.115",
  "trellis-story-utils": "/trellis-story-utils/static-1.4984",
  "storybook-react": "/storybook-react/static-1.44",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16689",
  "browser-eslint": "/browser-eslint/static-2.57",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57385",
  "hub-http-contrib": "/hub-http-contrib/static-1.3519",
  "tinymce-data": "/tinymce-data/static-1.41500",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5688",
  "layout-dnd-components": "/layout-dnd-components/static-1.13245",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12220",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16980",
  "academy-common-lib": "/academy-common-lib/static-1.15502",
  "outpost": "/outpost/static-1.4615",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3499",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9375",
  "ContentData": "/ContentData/static-1.69577",
  "layout-data-lib": "/layout-data-lib/static-1.10545",
  "academy-service-client": "/academy-service-client/static-1.4178",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4883",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7869",
  "wootric-nps": "/wootric-nps/static-1.7305",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.83",
  "advanced-menus-core": "/advanced-menus-core/static-1.15835",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12582",
  "ExportDialog": "/ExportDialog/static-6.10859",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35225",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15834",
  "simple-menus-lib": "/simple-menus-lib/static-1.17351",
  "settings-ui-lib": "/settings-ui-lib/static-1.13014",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11027",
  "immutable-less": "/immutable-less/static-1.5138",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8440",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4401",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8613",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1611",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4623",
  "simple-data-table": "/simple-data-table/static-1.3845"
}
};
